import { notifications } from '@mantine/notifications';
import { Logger } from 'src/utils/Logger';

export const notifyAndLogError = (
  title: string,
  message: string,
  error: unknown,
  additionalInfo: Record<string, unknown> = {},
) => {
  notifications.show({ title, message, color: 'red' });
  Logger.error(`${title}: ${message}`, error, additionalInfo);
};

export const notifyAndWarn = (
  title: string,
  message: string,
  additionalInfo: Record<string, unknown> = {},
) => {
  notifications.show({ title, message, color: 'amber' });
  Logger.warn(`${title}: ${message}`, additionalInfo);
};
